import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getOGARemarks } from '../../../../../redux/features/croSlice';
import GlobalTableGenerator from '../../../../../components/GlobalTableGenerator';
import { Chip, Stack } from '@mui/material';

export default function OGARemarksContent({ CROAssignID, name, course, classType, contactNumber }) {
  const ogaremarkscrd = useSelector((state) => state.cro?.ogaremarkscrd);
  const loading = useSelector((state) => state.cro?.ogaremarkscrd?.loading);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getOGARemarks(CROAssignID));
  }, [CROAssignID, dispatch]);

  const columns = [
    {
      field: 'sro_remarks_student_details',
      headerName: 'Student Details (In Brief)',
      width: 150,
    },
    {
      field: 'sro_remarks_subjects_sessions',
      headerName: 'Subjects & Session Count per Subject',
      width: 260,
    },
    {
      field: 'sro_fee_per_session',
      headerName: 'Fee per Session',
      width: 100,
      valueFormatter: (params) => (params?.value ? `₹ ${params.value}` : '-'),
    },
    {
      field: 'sro_class_per_week',
      headerName: 'Session per Week',
      width: 100,
    },
    {
      field: 'sro_remarks_time_prefered',
      headerName: 'Time Preferred',
      width: 300,
    },
    {
      field: 'sro_remarks_trainer_prefered',
      headerName: 'Trainer Preferred',
      width: 130,
    },
    {
      field: 'sro_remarks_total_fees',
      headerName: 'Total Fees',
      width: 100,
      valueFormatter: (params) => (params?.value ? `₹ ${params.value}` : '-'),
    },
    {
      field: 'sro_remarks_fee_status',
      headerName: 'Fee Status',
      width: 100,
    },
  ];

  const studentInfo = [
    { label: 'Name', value: name },
    { label: 'Contact No', value: contactNumber },
    { label: 'Class', value: classType },
    { label: 'Course', value: course },
  ];
  return (
    <Stack gap={2}>
      <Stack direction={'row'} spacing={2}>
        {studentInfo.map((item, index) => (
          <Chip
            key={index}
            label={`${item.label} : ${item.value ?? '-'}`}
            color="primary"
            variant="outlined"
            sx={{ mr: 1, mb: 1 }}
          />
        ))}
      </Stack>

      <GlobalTableGenerator
        columns={columns}
        loading={loading}
        rows={[ogaremarkscrd]}
        TableContainerStyle={{
          border: '1px solid #c9c6c6ff',
          borderRadius: 1,
          borderCollapse: 'collapse',
          '& .MuiTableCell-root': {
            border: '1px solid #d9d9d9',
          },
        }}
      />
    </Stack>
  );
}
